import { IPCameraStreamId } from 'types/models/ip-camera';

export type EventReasonPromptPreference = {
  snoozedUntil: number;
};

export interface IPCameraPreference {
  streamId: IPCameraStreamId;
}

export interface SamplePointPreference {
  graphYAxisBeginsAtZero?: boolean;
}

export enum EntityKind {
  EVENT_REASON_PROMPT = 'event-reason-prompt',
  IP_CAMERA = 'ip-camera',
  SAMPLE_POINT = 'sample-point'
}

export type EntityId = string;

export type PreferenceValue =
  | EventReasonPromptPreference
  | IPCameraPreference
  | SamplePointPreference;

export interface UserPreference {
  id: number;
  userId: number;
  entityKind: EntityKind;
  entityId: EntityId;
  preference: PreferenceValue;
}
